"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var billsBuilder = function billsBuilder(_a) {
  var _b;

  var _c = _a.bills,
      bills = _c === void 0 ? [] : _c;

  if (bills.length === 0 || bills.includes(_SearchFilters.BillsValue.INCLUDED) && bills.includes(_SearchFilters.BillsValue.EXCLUDED)) {
    return '';
  }

  return (_b = {}, _b[_SearchFilters.BillsValue.INCLUDED] = 'utilities:I', _b[_SearchFilters.BillsValue.EXCLUDED] = 'utilities:E OR utilities:P', _b)[bills[0]];
};

var _default = billsBuilder;
exports["default"] = _default;